import type { DashboardMetric } from "@/pages/dashboard/types";
import MetricCard from "@/pages/dashboard/components/metric-card";

interface MetricsRowProps {
  metrics: DashboardMetric[];
}

const MetricsRow = ({ metrics }: MetricsRowProps) => {
  return (
    <div className="flex flex-wrap gap-6 items-stretch w-full">
      {metrics.map((metric) => (
        <div key={metric.label} className="flex-1 min-w-[220px]">
          <MetricCard metric={metric} />
        </div>
      ))}
    </div>
  );
};

export default MetricsRow;
